import { SettingsFile } from 'hyarchis-global/environment';
import './styles/styles.scss';

// eslint-disable-next-line import/prefer-default-export
export const EnvironmentFile: SettingsFile = {
  filePath: `${process.env.PUBLIC_URL}/${
    process.env.NODE_ENV === 'production' ? '' : 'local.'
  }environment.js`,
  stateKey: 'ENVIRONMENT',
  localStorageKey: 'environment-settings',
};
